import React, { useState, useEffect } from "react";
import AcService from "./seo-content/ac-service";
import CarRepair from "./seo-content/car-repair";
import CarWash from "./seo-content/car-wash";
import Battery from "./seo-content/battery";
import TiresWheels from "./seo-content/tires-wheels";
import MobileMechanic from "./seo-content/mobile-mechanic";
import CarCare from "./seo-content/car-care";
import ServiceContract from "./seo-content/service-contract";
import OilChange from "./seo-content/oil-change";
import { useRouter } from "next/router";
import Breakdown from "./seo-content/breakdown";
import Inspection from "./seo-content/inspection";
import { connect } from "react-redux";
import { current } from "@reduxjs/toolkit";

const ServiceContent = ({ globalData }) => {
  const router = useRouter();
  let category = "";
  if (typeof localStorage !== "undefined") {
    category = localStorage.getItem("selected-service");
  }
  let CurrentPage = "";
  if (category) {
    CurrentPage = category;
  } else {
    CurrentPage =
      router?.query && router?.query?.slug?.length
        ? router?.query?.slug[1]
        : "";
  }
  return (
    <>
      {CurrentPage == "oil-change" ? (
        <OilChange globalData={globalData} />
      ) : null}
      {CurrentPage == "ac-service" ? (
        <AcService globalData={globalData} />
      ) : null}
      {CurrentPage == "car-wash-at-home" ? (
        <CarWash globalData={globalData} />
      ) : null}
      {CurrentPage == "repair" ? <CarRepair globalData={globalData} /> : null}
      {CurrentPage == "battery" ? <Battery globalData={globalData} /> : null}
      {CurrentPage == "tires-wheels" ? (
        <TiresWheels globalData={globalData} />
      ) : null}
      {CurrentPage == "mobile-mechanic" ? (
        <MobileMechanic globalData={globalData} />
      ) : null}
      {CurrentPage == "car-care" ? <CarCare globalData={globalData} /> : null}
      {CurrentPage == "breakdown" ? (
        <Breakdown globalData={globalData} />
      ) : null}
      {CurrentPage == "service-contract" ? (
        <ServiceContract globalData={globalData} />
      ) : null}
      {CurrentPage == "inspection" ? (
        <Inspection globalData={globalData} />
      ) : null}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    apiData: state.apiData,
    globalData: state.globalData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ServiceContent);

// export default ServiceContent;
